//const SERVER_URL = "https://dev.inlab.istanbul/bia/public";
//const SERVER_URL = "http://bia-api.test";
const SERVER_URL = "https://bia.turkonfed.org";

export default SERVER_URL;
